import React from 'react';




function UserTableHead(){
  
                    return (
                        <tr>
                            <th>id</th>
                            <th>Nombre</th>
                            <th>Telefono</th>
                            <th>Mail</th>
                            <th>Direccion</th>
                        </tr>
                            
                        )
    }
    
        

export default UserTableHead;